<template>
  <custom-callout
    class="my-4 approve-user-callout-styles"
    :has-toggle="false"
    border-color="orange"
  >
    <icon-view
      class="mt-5 mb-3 mt-md-0 mt-sm-5 approve-user-callout-icon"
      :title="title"
      :icon="icon"
      :icon-background="iconBackground"
      :icon-color="iconColor"
      :icon-size="iconSize"
    />
    <validation-observer ref="approveRef">
      <div class="row">
        <div class="col-3">
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            vid="approveUsername"
            :custom-messages="{
              required: 'El usuario es requerido.',
            }"
          >
            <custom-input
              id="approve-user-input"
              v-model="model.username"
              label="Nombre del Usuario:"
              :disabled="disabled || value.username !== null"
              :error="errors[0]"
            />
          </validation-provider>
        </div>
        <div class="pl-md-5 col-md-5 col-12 mb-md-0 mb-3 mr-md-4">
          <validation-provider rules="required" v-slot="{ errors }">
            <custom-radio
              id="approve-user-radio"
              v-model="model.authMode"
              class="inline-grey-radio"
              :options="authModeOptions"
              name="authMode"
              label="Autenticación:"
              :error="errors[0]"
              is-inline
              :is-disabled="disabled"
              custom-error-msg="La autentificación es requerida."
            />
          </validation-provider>
        </div>
        <div
          v-if="!disabled"
          class="
            col-12
            my-4
            pl-md-4
            ml-md-5
            d-flex
            flex-column flex-md-row
            justify-content-md-end
            col-md-3
            align-self-center
          "
        >
          <action-button
            id="approve-user-cancel-btn"
            i="fas fa-times-circle"
            text="Cancelar"
            variant="outline-danger mb-2 mb-md-0 mr-md-2"
            @click="$emit('on-cancel')"
          />
          <action-button
            id="approve-user-save-btn"
            i="fas fa-save"
            text="Guardar"
            variant="success pl-3 pr-3"
            @click="onSave()"
          />
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import CustomRadio from '@/components/common/CustomRadio';
import ActionButton from 'ActionButton';
import { authModeOptions } from '@/utils/constants/authenticationModes.js';

export default {
  name: 'ApproveUserCallout',
  components: {
    CustomCallout,
    IconView,
    CustomInput,
    CustomRadio,
    ActionButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    iconBackground: {
      type: String,
      default: 'white',
    },
    iconColor: {
      type: String,
      default: '#ff7058',
    },
    iconSize: {
      type: String,
      default: '16px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: null,
      authModeOptions,
    };
  },
  created() {
    if (this.value) {            
      this.model = Object.assign({}, this.value);
    }
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.approveRef.validate();
      if (!isValid) {
        return;
      } else {
        this.$emit('input', this.model);
      }
    },
    setErrors(value) {
      this.$refs.approveRef.setErrors(value);
    },
  },
};
</script>

<style lang="scss">
@import '@/sass/config/_colors.scss';

.approve-user-callout-icon > * em {
  margin-top: 0 !important;
}

.approve-user-callout-styles > div.bg-secondary-3 {
  padding-top: 20px !important;
  padding-bottom: 30px !important;
}

.approve-user-callout-styles > * label {
  font-weight: normal;
}

.approve-user-callout-styles > * textarea:disabled {
  background: #e2e2e2 !important;
}

::v-deep .inline-grey-radio {
  .input-label {
    color: map-get($colors, 'gray-6');
    font-size: 0.875rem;
  }
}
</style>
